import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

interface UnshareData extends Types.IApi.Unshare.Request {
  collectionId: string;
}

const useUnshare = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ collectionId, ...data }: UnshareData) => {
      await Api.unshare(collectionId, data);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['collections', 'single', variables.collectionId] });
      toast.success('Share removed', {
        description: 'Collection share has been removed.',
      });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to remove share',
      });
    },
  });
};

export default useUnshare;
